<template>
  <div>
    <page-title
      :left-btns="leftBtns"
      :right-btns="rightBtns"
      @leftClick="leftClickHandler"
    ></page-title>
    <ra-search-box
      class="mt-4"
      :search-fields="wageSearchColumns"
      :showBton="false"
      @autoSearch="wageSearchHandler"
      v-if="activeName == 'accountant_view'"
    ></ra-search-box>
    <div v-if="activeName == 'accountant_view'">
      <div class="wage_table mt-4"  v-loading="wage_loading" v-if="wage_list_data.length>0">
          <el-table
            :data="wage_list_data"
            style="width: 100%"
            :default-sort="{prop: 'driverName', order: 'ascending'}"
          >
            <el-table-column
              prop="driver_name"
              label="Driver's name"
              width="200"
              align="center"
              :fixed="true"
            >
            </el-table-column>
            <el-table-column
              prop="pickup_commission"
              label="Pickup Commission"
              align="center"
              width="100"
            >
              <template slot-scope="scope">
                <div class="grid-content bg-purple" style="cursor: pointer" @click="changeInputHandle(scope.row,1)">
                  <template  v-if="scope.row.show_pcom_input">
                    <el-input v-model="scope.row.pickup_commission"
                              :ref="`pcom${scope.row.wage_id}`"
                              @blur="showOutHandleTwo(scope.row)"
                              maxlength='6'
                              @keyup.enter.native="showOutHandleTwo(scope.row)"
                    ></el-input>
                  </template>
                  <span v-else>{{scope.row.pickup_commission}}</span>
                </div>

              </template>
            </el-table-column>
            <el-table-column
              prop="delivery_commission"
              label="Delivery Commission"
              align="center"
              width="120"
            >
              <template slot-scope="scope">
                <div class="grid-content bg-purple" style="cursor: pointer" @click="changeInputHandle(scope.row,2)">
                  <template  v-if="scope.row.del_input">
                    <el-input v-model="scope.row.delivery_commission"
                              :ref="`delivery${scope.row.wage_id}`"
                              @blur="showOutHandleTwo(scope.row)"
                              maxlength='6'
                              @keyup.enter.native="showOutHandleTwo(scope.row)"
                    ></el-input>
                  </template>
                  <span v-else>{{scope.row.delivery_commission}}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="pickup_quan" label="Pickup Quan."  width="100">
            </el-table-column>
            <el-table-column align="center" prop="delivery_quan" label="Delivery Quan."  width="100">
            </el-table-column>
            <el-table-column align="center" prop="pickup_amount" label="Pickup Amount"  width="100">
            </el-table-column>
            <el-table-column align="center" prop="delivery_amount" label="Delivery Amount"  width="100">
            </el-table-column>
            <el-table-column align="center" prop="basic_wage" label="Basic"> </el-table-column>
            <el-table-column align="center" prop="bonus" label="Bonus">
              <template slot-scope="scope">
                <div class="grid-content bg-purple" style="cursor: pointer" @click="changeInputHandle(scope.row,3)">
                  <template  v-if="scope.row.bonus_input">
                    <el-input v-model="scope.row.bonus"
                              :ref="`bonus${scope.row.wage_id}`"
                              @blur="showOutHandleTwo(scope.row, 'bonus')"
                              maxlength='7'
                              @keyup.enter.native="showOutHandleTwo(scope.row, 'bonus')"
                    ></el-input>
                  </template>
                  <span v-else>{{scope.row.bonus}}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="adjust" label="Adjust.">
              <template slot-scope="scope">
                <div class="grid-content bg-purple" style="cursor: pointer" @click="changeInputHandle(scope.row,4)">
                  <template  v-if="scope.row.adjust_input">
                    <el-input v-model="scope.row.adjust"
                              :ref="`bonus${scope.row.wage_id}`"
                              @blur="showOutHandleTwo(scope.row, 'adjust')"
                              maxlength='7'
                              @keyup.enter.native="showOutHandleTwo(scope.row, 'adjust')"
                    ></el-input>
                  </template>
                  <span v-else>{{scope.row.adjust}}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="subtotal" label="Subtotal">
            </el-table-column>
            <el-table-column align="center" prop="hst" label="HST">

              <template slot-scope="scope">
                <div class="grid-content bg-purple" style="cursor: pointer" @click="changeInputHandle(scope.row,5)">
                  <template  v-if="scope.row.show_hst_input">
                    <el-select v-model="scope.row.hst"
                               @change="showOutHandleTwo(scope.row)"
                               :ref="`hst${scope.row.wage_id}`"
                    >
                      <el-option label="Incl." value="Incl"></el-option>
                      <el-option label="Excl." value="Excl"></el-option>
                      <el-option label="Out." value="Out"></el-option>
                    </el-select>
                  </template>
                  <span v-else>{{scope.row.hst}}</span>
                </div>
              </template>


            </el-table-column>
            <el-table-column align="center" prop="total_amount" label="Total"> </el-table-column>
            <el-table-column label="Action" width="120" fixed="right">
              <template slot-scope="scope">
                <div class="action">
                  <span @click="noteHandler(scope.row)" class="cursor-pointer relative">
                       <img src="../../assets/wage/edit@2x.png" class="w-4 mr-4" alt="">
                      <span v-if="scope.row.wage_note != ''" class="absolute top-1 right-3 w-1.5 h-1.5 bg-red-500 rounded-full"></span>
                    <!--                      <span class="absolute top-1 right-3 w-1.5 h-1.5 bg-green-500 rounded-full"></span>-->
                  </span>
                  <span @click="emailHandler(scope.row)" class="cursor-pointer relative">
                      <img src="../../assets/wage/edit@2x(1).png" class="w-4 mr-4" alt="">
                      <span v-if="scope.row.is_upload == 1" class="absolute top-1 right-3 w-1.5 h-1.5 bg-green-500 rounded-full"></span>
<!--                    <span class="absolute top-1 right-3 w-1.5 h-1.5 bg-red-500 rounded-full"></span>-->
                  </span>
                </div>
              </template>
            </el-table-column>
          </el-table>
      </div>
      <table-empty v-else></table-empty>
    </div>
    <div v-else>
       <businessView></businessView>
    </div>
<!--    note弹框-->
    <el-dialog
      title="Note"
      :visible.sync="noteDialogVisible"
      width="530px">
      <div class="mt-4">
        <el-input
          type="textarea"
          maxlength="200"
          v-model="note_input" placeholder="Note"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="noteDialogVisible = false" plain class="changeFocus border-black text-black">Cancle</el-button>
        <el-button type="success" class="w-[80px] p-0" @click="editNoteHandler">Save</el-button>
      </span>
    </el-dialog>
<!--    email 弹框-->
    <el-dialog
      :title="emailTitle"
      :visible.sync="emailDialogVisible"
      v-loading="isEmailClicked"
      width="530px">
      <div class="mt-4">
        {{email_mes}}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="emailDialogVisible = false" plain class="changeFocus border-black text-black">No</el-button>
        <el-button type="success" class="w-[80px] p-0" @click="emailConfirmHandler">Yes</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {getDriverDropList, getWageList, updateNote, updateUploadStatus, updateWage} from "@/api/wageReview";
import businessView from "./businessView";
export default {
  components: {businessView},
  data(){
    return {
      emailTitle:"Email the wage statement",
      email_mes:'',
      emailDialogVisible:false,
      isEmailClicked: false,
      note_input:'',
      note_select_item:"",
      noteDialogVisible:false,
      activeName: 'accountant_view',
      leftBtns: [
        {
          label: 'Accountant View',
          name: 'accountant_view'
        },
        {
          label: 'Business View',
          name: 'business_view',
        }
      ],
      rightBtns:[],
      wageSearchColumns:[
        {
          type: 'select',
          prop: 'driver',
          label: 'Driver',
          placeholder: 'All Driver',
          options: []
        },
        {
          type: 'select',
          prop: 'year',
          label: 'Year',
          placeholder: 'All',
          defaultValue: '',
          options: []
        },
        {
          type: 'select',
          prop: 'type',
          label: 'Period',
          placeholder: 'All',
          defaultValue: '',
          options: []
        },

      ],
      wage_loading:false,
      wage_list_data:[],
      input_year:'',
      option_year:[],
      input_date:'',
      option_date:[],
      start_time:"",
      end_time:'',
      driver_id:'',
    }
  },
  created() {
    this.option_year = this.getYearFrom2021()
    this.option_date = this.getTwoWeekRanges(this.input_year)
    this.input_date = this.getCurrentTimeRange()
    this.start_time = this.convertTimeString(this.input_year, this.input_date).start_time
    this.end_time = this.convertTimeString(this.input_year, this.input_date).end_time
    this.option_year.forEach(item=>{this.wageSearchColumns[1].options.push({label:item, value:item})})
    this.option_date.forEach(item=>{this.wageSearchColumns[2].options.push({label:item, value:item})})
    this.wageSearchColumns[1].defaultValue = this.input_year
    this.wageSearchColumns[2].defaultValue = this.input_date
    this.getDriverDropListHandle()
    this.getWageListData()
  },
  methods:{
    leftClickHandler(row){
      this.activeName = row
    },
    wageSearchHandler(data){
      console.log(data.type,data.year,'dd')
      this.start_time = this.convertTimeString(data.year, data.type).start_time
      this.end_time = this.convertTimeString(data.year, data.type).end_time
      const driverOption = this.wageSearchColumns[0].options.find(item => item.label === data.driver);
      if (driverOption) {
        this.driver_id = driverOption.value;
      }

      this.getWageListData()
    },
    noteHandler(row){
      this.note_input=row.wage_note
      this.note_select_item = row
      this.noteDialogVisible = true;
    },
    emailHandler(row){
      if (row.is_upload == 1){
        // 已经上传
        this.emailTitle = 'Resend the wage statement'
        this.email_mes = 'Would you like to email the wage statement to this driver?'
      }else {
        this.emailTitle = 'Email the wage statement'
        this.email_mes = 'Would you like to resend the wage statements to this driver?'
      }
      this.note_select_item = row
     this.emailDialogVisible = true
    },
    emailConfirmHandler(){
      if (this.isEmailClicked) return
      this.isEmailClicked = true
      console.log(this.note_select_item,'note_select_item')
      updateUploadStatus({
        wage_id:this.note_select_item.wage_id,
        is_upload:1
      }).then(res=>{
        if (res.code == 200){
          this.$message({
            type:"success",
            message:res.msg
          })
          this.emailDialogVisible = false
          this.getWageListData()
        }else {
          this.$message({
            type:"error",
            message:res.msg
          })
        }
        setTimeout(() => {
          this.isEmailClicked = false
        }, 200)
      })
    },
    editNoteHandler(){
      updateNote({
        wage_id:this.note_select_item.wage_id,
        wage_note:this.note_input
      }).then(res=>{
        if (res.code == 200){
          this.$message({
            type:"success",
            message:res.msg
          })
          this.noteDialogVisible = false
          this.getWageListData()
        }else {
          this.$message({
            type:"error",
            message:res.msg
          })
        }
      })
    },
    changeInputHandle(row,type){
      const index = this.wage_list_data.findIndex(item => item.wage_id === row.wage_id);
      if (index === -1) return;
      const inputFlags = {
        1: 'show_pcom_input',
        2: 'del_input',
        3: 'bonus_input',
        4: 'adjust_input',
        5:'show_hst_input'
      };
      const flag = inputFlags[type];
      if (flag) {
        this.$set(this.wage_list_data[index], flag, true);
      }
      this.wage_list_data = JSON.parse(JSON.stringify(this.wage_list_data));
      this.$forceUpdate()
      this.$nextTick(() => {
        const refInput = this.$refs[`${flag}${row.wage_id}`];
        if (refInput) {
          refInput.focus();
        }
      });
    },
    changeSelectHandle(row){
    },
    showOutHandleTwo(row, prop){
      if (prop && ['bonus', 'adjust'].includes(prop)) {
        if (row[prop] > 9999.99 || row[prop] < 0) {
          return this.$message.error(`${prop} can only be before 0-9999.99`)
        }
      }
      const index = this.wage_list_data.findIndex(item => item.wage_id === row.wage_id);
      if (index !== -1) {
        this.wage_list_data[index].show_pcom_input = false;
        this.wage_list_data[index].del_input = false;
        this.wage_list_data[index].bonus_input = false
        this.wage_list_data[index].adjust_input = false
        this.wage_list_data[index].show_hst_input = false
        this.wage_list_data = JSON.parse(JSON.stringify(this.wage_list_data));
      }
      this.$forceUpdate()
      // 调用接口 将当前修改的值传给后端
      this.updataWageListHandle(row)
    },
    updataWageListHandle(row){
      row.pickup_commission = Number(row.pickup_commission .slice(0, -1));
      row.delivery_commission = Number(row.delivery_commission .slice(0, -1));
      updateWage({
        wage_id:row.wage_id,
        pickup_commission:row.pickup_commission,
        delivery_commission:row.delivery_commission,
        bonus:row.bonus,
        adjust:row.adjust,
        hst:row.hst
      }).then(res=>{
          if (res.code == 200) {
            this.$message({
              type:"success",
              message:res.msg
            })
           this.getWageListData()
          }else {
            this.$message({
              type:'error',
              message:res.msg
            })
          }
      })
    },
    getWageListData(){
      getWageList({
        start_time:this.start_time,
        end_time:this.end_time,
        driver_id:this.driver_id
      }).then(res=>{
          if(res.code == 200){
            this.wage_list_data = res.data
            this.wage_list_data.forEach(v=>{
              v.show_pcom_input = false
              v.del_input = false
              v.bonus_input = false
              v.adjust_input =false
              v.show_hst_input = false
            })
          }else {
            this.$message({
              type:"error",
              message:res.msg
            })
          }
      })
    },
    getDriverDropListHandle(){
      getDriverDropList({
        start_time:this.start_time,
        end_time:this.end_time,
      }).then(res=>{
        if (res.code == 200){
          res.data.forEach(v=>{
            this.wageSearchColumns[0].options.push({
              label:v.name,
              value:v.driver_id
            })
          })
          this.wageSearchColumns[0].options.push({
            label:'All',
            value:''
          })
        }

      })
    },
    wageClearSearchHandler(){

    },
    //获取从2021 到当前的年份
    getYearFrom2021(){
      const currentYear = new Date().getFullYear();
      this.input_year = currentYear
      const startYear = 2021;
      const years = [];
      for (let year = startYear; year <= currentYear; year++) {
        years.push(year);
      }
      return years;
    },
    //输入一个年份 然后根据年份显示出所选年份中 以每个月每两周的为一个时间周期 显示
    getTwoWeekRanges(year){
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      const result = [];
      for (let monthIndex = 11; monthIndex >= 0; monthIndex--) {
        const month = months[monthIndex];
        const lastDayOfMonth = new Date(year, monthIndex + 1, 0).getDate();
        // 第二时间段的结束日期
        const secondRangeEnd = lastDayOfMonth;
        // 第二时间段的开始日期
        const secondRangeStart = Math.max(15, lastDayOfMonth - 16);
        // 第一时间段的结束日期
        const firstRangeEnd = Math.min(14, secondRangeStart - 1);
        // 第一时间段的开始日期
        const firstRangeStart = Math.max(1, firstRangeEnd - 14);
        // 构建时间范围字符串并加入结果数组
        const secondRangeStr = `${month} ${secondRangeStart}-${secondRangeEnd}`;
        const firstRangeStr = `${month} ${firstRangeStart}-${firstRangeEnd}`;
        result.push(secondRangeStr, firstRangeStr);
      }
      return result.reverse(); // 倒序排列结果数组
    },
    //根据当前时间 动态计算period回显时间
    getCurrentTimeRange() {
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      const currentMonth = currentDate.getMonth();
      const currentDay = currentDate.getDate();
      const lastDayOfMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
      const secondRangeEnd = lastDayOfMonth;
      const secondRangeStart = Math.max(15, lastDayOfMonth - 16);
      const firstRangeEnd = Math.min(14, secondRangeStart - 1);
      const firstRangeStart = Math.max(1, firstRangeEnd - 14);
      const month = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
      ][currentMonth];
      // 构建时间范围字符串
      const firstRangeStr = `${month} ${firstRangeStart}-${firstRangeEnd}`;
      const secondRangeStr = `${month} ${secondRangeStart}-${secondRangeEnd}`;
      return currentDay <= 14 ? firstRangeStr : secondRangeStr;
    },
    //修改 year 或者 period 或者司机时 都会触发以下事件 传入两个参数 然后返回一个开始时间 一个结束时间
    convertTimeString(year, dateRangeString) {
      const [month, days] = dateRangeString.split(' ');
      const [startDay, endDay] = days.split('-').map(day => day.padStart(2, '0'));

      const startDate = new Date(`${year} ${month} ${startDay}`);
      const endDate = new Date(`${year} ${month} ${endDay}`);

      const start_time = this.formatDate(startDate);
      const end_time = this.formatDate(endDate);

      return { start_time, end_time };
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');

      return `${year}-${month}-${day}`;
    },
  }
}
</script>
<style scoped lang="less">
.wage_table{
  /deep/.el-input__inner{
    width: 80px;
    border-radius: 8px;
  }
}
/deep/.el-textarea__inner{
  min-height: 150px !important;
}
/deep/.el-textarea__inner:focus{
  border-color: #000;
}
.bg-red-500 {
  background-color: #EB3F3F; /* 红色 500 色调来自 Tailwind CSS */
}

.rounded-full {
  border-radius: 9999px; /* 创建一个圆形 */
}
.bg-green-500 {
  background-color: #82D237; /* 绿色 500 色调来自 Tailwind CSS */
}

.rounded-full {
  border-radius: 9999px; /* 创建一个圆形 */
}
</style>
